// Client-side email service that calls our Vercel serverless function
// This avoids CORS issues by keeping Resend API calls on the server-side

// Debug: Check if email module is being loaded
console.log('📧 EMAIL_MODULE_LOADED: Email module loaded successfully');

export interface IdeaNotificationData {
  id: string;
  uniqueId: string;
  title: string;
  description: string;
  category: string;
  status: string;
  owner: {
    name: string;
    email: string;
  };
  effort: number;
  value: number;
  score: number;
  tags: string[];
  dateSubmitted: Date;
}

/**
 * Send email notification when a new idea is submitted
 * Calls our Vercel serverless function to avoid CORS issues
 */
export const sendNewIdeaNotification = async (ideaData: IdeaNotificationData): Promise<void> => {
  console.log('📧 EMAIL_ATTEMPT: Sending notification for idea:', ideaData.title);

  try {
    console.log('🌐 EMAIL_CALLING_API: Making request to /api/send-email');

    const response = await fetch('/api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ideaData }),
    });

    console.log('📡 EMAIL_API_RESPONSE:', response.status, response.statusText);

    if (!response.ok) {
      const errorData = await response.json();
      console.error('❌ EMAIL_API_ERROR:', errorData);
      throw new Error(`Email API error: ${response.status} - ${errorData.error}`);
    }

    const result = await response.json();
    console.log('✅ EMAIL_SUCCESS: Notification sent for:', ideaData.title);
    console.log('📬 EMAIL_RESULT:', result);
  } catch (error) {
    console.error('❌ EMAIL_EXCEPTION:', error);
    console.error('🔍 EMAIL_ERROR_DETAILS:', error);
    // Don't throw - we don't want email failures to break the app
  }
};

